import React from 'react';

const Logo = ({ variant = 'horizontal', size = 'default', className = '', linkTo = '/', noLink = false }) => {
  // Sizes for horizontal logo
  const horizontalSizes = {
    small: 'h-8',
    default: 'h-12',
    large: 'h-16',
    xlarge: 'h-24',
    xxlarge: 'h-32'
  };

  // Sizes for vertical logo
  const verticalSizes = {
    small: 'h-16',
    default: 'h-24',
    large: 'h-32',
    xlarge: 'h-40',
    xxlarge: 'h-48'
  };

  const sizes = variant === 'vertical' ? verticalSizes : horizontalSizes;
  const src = variant === 'vertical' ? '/logo-vertical.png' : '/logo-horizontal.png';

  const imgElement = (
    <img 
      src={src} 
      alt="10 Millions Investor" 
      className={`${sizes[size]} w-auto object-contain`}
    />
  );

  if (noLink) {
    return (
      <div className={`flex items-center ${className}`}>
        {imgElement}
      </div>
    );
  }

  // Dynamic import to avoid circular dependencies
  const { Link } = require('react-router-dom');
  
  return (
    <Link to={linkTo} className={`flex items-center ${className}`}>
      {imgElement}
    </Link>
  );
};

export default Logo;
